"use client"
import React, {useState, useEffect} from "react";
import WrapSodyMobileScroll from "./MobileScroll";
import WrapsodyGsapScroll from "./GsapScroll";

export default function WrapsodyScroll(props) {

    const [isMobile, setIsMobile] = useState(null);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 800px)");

        const handleMediaQueryChange = (event) => {
            setIsMobile(event.matches);
        };

        // Set initial value
        setIsMobile(mediaQuery.matches);

        // Listen for changes
        mediaQuery.addEventListener('change', handleMediaQueryChange);

        // Cleanup listener on component unmount
        return () => {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
        };
    }, []);

    return (
        <>
            {isMobile? <WrapSodyMobileScroll data={props}/>:<WrapsodyGsapScroll data={props}/>}
        </>
    )
}